import { defineComponent as k, useCssVars as T, unref as p, ref as b, computed as x, openBlock as v, createElementBlock as m, createElementVNode as r, normalizeClass as z, createTextVNode as te, toDisplayString as _, createVNode as $, Transition as pe, withCtx as C, Fragment as W, renderList as D, createCommentVNode as I, h as O, renderSlot as L, useSlots as ve, useTemplateRef as q, watch as U, onMounted as me, createBlock as j, Teleport as _e, mergeProps as fe, getCurrentScope as ge, onScopeDispose as he } from "vue";
import { s as B, p as R, F as we, Z as A, a as ae, x as Z, C as be, _ as E, k as xe } from "../review.es.js";
const ye = (a, e) => {
  const t = "http://www.w3.org/2000/svg", s = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 6.97a.75.75 0 011.06 0L10 11.44l4.47-4.47a.75.75 0 111.06 1.06l-5 5a.75.75 0 01-1.06 0l-5-5a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (a.title) {
    const o = document.createElementNS(t, "title");
    o.textContent = a.title, s.appendChild(o);
  }
  const l = Array.from((s == null ? void 0 : s.attributes) ?? []).reduce((o, i) => ({
    ...o,
    [i.name]: i.value
  }));
  return O(
    "svg",
    {
      ...l,
      ...e.attrs,
      role: "img",
      innerHTML: s.innerHTML
    }
  );
}, $e = ["tabindex", "aria-expanded", "aria-label"], ke = {
  key: 0,
  id: "custom-select-items",
  class: "items",
  role: "listbox"
}, Se = ["aria-selected", "onClick"], ze = /* @__PURE__ */ k({
  __name: "CustomSelect",
  props: {
    options: {},
    modelValue: {},
    tabindex: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    T((w) => ({
      "97018cb2": `${p(i)}px`
    }));
    const t = a, s = e, { t: l } = R(), o = b(), {
      width: i
    } = we(o), n = b(!1), c = x({
      get() {
        return t.modelValue;
      },
      set(w) {
        s("update:modelValue", w);
      }
    }), g = x(() => {
      var w;
      return (w = t.options.find((S) => S.value === c.value)) == null ? void 0 : w.label;
    }), d = x(() => t.options.findIndex((w) => w.value === c.value));
    function u() {
      d.value < t.options.length - 1 && (c.value = t.options[d.value + 1].value);
    }
    function h() {
      d.value > 0 && (c.value = t.options[d.value - 1].value);
    }
    return A("ArrowDown", () => {
      n.value ? u() : n.value = !0;
    }, { target: o }), A("ArrowUp", () => {
      h();
    }, { target: o }), A("Escape", (w) => {
      n.value && (w.stopPropagation(), n.value = !1);
    }, { target: o }), (w, S) => (v(), m("div", {
      class: "custom-select",
      onBlur: S[1] || (S[1] = (y) => n.value = !1)
    }, [
      r("button", {
        ref_key: "selectedElement",
        ref: o,
        type: "button",
        role: "combobox",
        tabindex: w.tabindex,
        "aria-expanded": n.value,
        "aria-haspopup": "",
        "aria-controls": "custom-select-items",
        "aria-label": t.options[0].label,
        class: z(["selected", { open: n.value }]),
        onClick: S[0] || (S[0] = (y) => n.value = !n.value)
      }, [
        te(_(g.value) + " ", 1),
        r("i", null, [
          $(p(ye), {
            "aria-label": p(l)("Arrow icon")
          }, null, 8, ["aria-label"])
        ])
      ], 10, $e),
      $(pe, { name: "fade" }, {
        default: C(() => [
          n.value ? (v(), m("div", ke, [
            (v(!0), m(W, null, D(w.options, (y) => (v(), m("div", {
              key: y.value,
              role: "option",
              tabindex: "-1",
              "aria-selected": c.value === y.value,
              class: z(["item", { active: c.value === y.value }]),
              onClick: (F) => {
                c.value = y.value, n.value = !1;
              }
            }, _(y.label), 11, Se))), 128))
          ])) : I("", !0)
        ]),
        _: 1
      })
    ], 32));
  }
}), Q = /* @__PURE__ */ B(ze, [["__scopeId", "data-v-da539965"]]), Ce = /* @__PURE__ */ k({
  __name: "List",
  props: {
    items: {},
    itemId: { type: Function }
  },
  setup(a) {
    const e = a;
    return (t, s) => (v(), m("ul", null, [
      (v(!0), m(W, null, D(e.items, (l, o) => (v(), m("li", {
        key: e.itemId ? e.itemId(l) : o
      }, [
        L(t.$slots, "default", { item: l }, void 0, !0)
      ]))), 128))
    ]));
  }
}), Le = /* @__PURE__ */ B(Ce, [["__scopeId", "data-v-b2eb0de9"]]), Te = { class: "recordGrid__item__name" }, Ie = { class: "recordGrid__item__value" }, Re = /* @__PURE__ */ k({
  __name: "RecordGrid",
  props: {
    items: {},
    direction: { default: "column" },
    responsive: { type: Boolean, default: !0 },
    fontSize: { default: "small" }
  },
  setup(a) {
    T((o) => ({
      38704221: o.direction,
      "36b2eaf8": l.value,
      d846e964: p(t),
      "40576db2": p(s)
    }));
    const e = a, t = e.direction === "row" ? "column" : "row", s = e.direction === "row" ? "center" : "end", l = x(() => e.direction === "row" ? "16px" : e.fontSize === "large" ? "8px" : "2.5px");
    return (o, i) => (v(), m("ul", {
      class: z([
        "recordGrid",
        `recordGrid--${e.direction}`,
        `recordGrid--${e.items.length}items`,
        `recordGrid--${e.fontSize}-fontsize`,
        { "recordGrid--responsive": e.responsive }
      ])
    }, [
      (v(!0), m(W, null, D(o.items, (n, c) => (v(), m("li", {
        class: "recordGrid__item",
        key: c
      }, [
        r("span", Te, [
          L(o.$slots, "name", { item: n }, () => [
            te(_(n.name), 1)
          ], !0)
        ]),
        r("span", Ie, [
          L(o.$slots, "value", { item: n }, void 0, !0)
        ])
      ]))), 128))
    ], 2));
  }
}), Ee = /* @__PURE__ */ B(Re, [["__scopeId", "data-v-ca152712"]]);
function oe(a) {
  return a === null ? null : a.scrollHeight > a.clientHeight ? a : oe(a.parentNode);
}
function se(a) {
  return ge() ? (he(a), !0) : !1;
}
const Fe = typeof window < "u", Pe = (a) => typeof a == "string", G = () => {
};
function le(a) {
  var e;
  const t = p(a);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const ne = Fe ? window : void 0;
function J(...a) {
  let e, t, s, l;
  if (Pe(a[0]) ? ([t, s, l] = a, e = ne) : [e, t, s, l] = a, !e)
    return G;
  let o = G;
  const i = U(() => p(e), (c) => {
    o(), c && (c.addEventListener(t, s, l), o = () => {
      c.removeEventListener(t, s, l), o = G;
    });
  }, { immediate: !0, flush: "post" }), n = () => {
    i(), o();
  };
  return se(n), n;
}
var X = Object.getOwnPropertySymbols, He = Object.prototype.hasOwnProperty, Ve = Object.prototype.propertyIsEnumerable, Oe = (a, e) => {
  var t = {};
  for (var s in a)
    He.call(a, s) && e.indexOf(s) < 0 && (t[s] = a[s]);
  if (a != null && X)
    for (var s of X(a))
      e.indexOf(s) < 0 && Ve.call(a, s) && (t[s] = a[s]);
  return t;
};
function Be(a, e, t = {}) {
  const s = t, { window: l = ne } = s, o = Oe(s, ["window"]);
  let i;
  const n = l && "ResizeObserver" in l, c = () => {
    i && (i.disconnect(), i = void 0);
  }, g = U(() => le(a), (u) => {
    c(), n && l && u && (i = new l.ResizeObserver(e), i.observe(u, o));
  }, { immediate: !0, flush: "post" }), d = () => {
    c(), g();
  };
  return se(d), {
    isSupported: n,
    stop: d
  };
}
var Y;
(function(a) {
  a.UP = "UP", a.RIGHT = "RIGHT", a.DOWN = "DOWN", a.LEFT = "LEFT", a.NONE = "NONE";
})(Y || (Y = {}));
function ee(a) {
  const e = b(0), t = b(0), s = b(0), l = b(0), o = b(0), i = b(0), n = b(0), c = b(0);
  function g() {
    const d = le(a);
    if (!d) {
      e.value = 0, t.value = 0, s.value = 0, l.value = 0, o.value = 0, i.value = 0, n.value = 0, c.value = 0;
      return;
    }
    const u = d.getBoundingClientRect();
    e.value = u.height, t.value = u.bottom, s.value = u.left, l.value = u.right, o.value = u.top, i.value = u.width, n.value = u.x, c.value = u.y;
  }
  return J("scroll", g, !0), J(window, "resize", g, !0), Be(
    a,
    g
  ), {
    height: e,
    bottom: t,
    left: s,
    right: l,
    top: o,
    width: i,
    x: n,
    y: c,
    update: g
  };
}
const Me = { class: "inner" }, Ne = /* @__PURE__ */ k({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    mode: { default: "hover" },
    modelValue: { type: Boolean, default: !0 },
    placement: { default: "top" },
    minWidth: { default: 0 },
    maxWidth: { default: 0 },
    nowrap: { type: Boolean, default: !0 },
    callbackHide: { type: Function, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    zIndexTooltip: { default: "9999" },
    colorScheme: { default: "info" },
    container: { default: "body" }
  },
  emits: [
    "visible"
  ],
  setup(a, { emit: e }) {
    const t = a, s = e, l = ve(), o = b(!1), i = q("tooltipWrapper"), n = q("tooltipElement"), c = ae(), {
      top: g,
      left: d,
      bottom: u,
      right: h,
      width: w,
      height: S,
      update: y
    } = ee(i), {
      width: F,
      height: M
    } = ee(n), ie = x(() => {
      switch (t.placement) {
        case "top":
        case "bottom":
          return d.value + (w.value - F.value) / 2;
        case "top-start":
        case "bottom-start":
          return d.value;
        case "top-end":
        case "bottom-end":
          return h.value - F.value;
        case "left":
          return d.value - F.value;
        case "right":
          return h.value;
        default:
          return 0;
      }
    }), re = x(() => {
      switch (t.placement) {
        case "top":
          return g.value - M.value;
        case "top-start":
        case "top-end":
          return g.value - M.value;
        case "bottom":
          return u.value;
        case "bottom-start":
        case "bottom-end":
          return u.value;
        case "left":
        case "right":
          return g.value + (S.value - M.value) / 2;
        default:
          return 0;
      }
    }), ce = x(() => ({
      "border-radius": c.borderRadius,
      left: `${ie.value}px`,
      top: `${re.value}px`,
      "z-index": t.zIndexTooltip,
      "white-space": t.nowrap ? "nowrap" : "normal",
      "min-width": t.minWidth > 0 ? `${t.minWidth}px` : "auto",
      "max-width": t.maxWidth > 0 ? `${t.maxWidth}px` : "none"
    }));
    function P() {
      o.value || (o.value = !0, y(), s("visible", !0));
    }
    function H() {
      o.value && (o.value = !1, s("visible", !1));
    }
    function N(f) {
      const K = t.mode === "hover" && f.type === "mouseleave", ue = t.mode === "click" && f.type === "click" && i.value && !i.value.contains(f.target);
      (K || ue) && H();
    }
    function V(f) {
      if (t.mode === "hover") {
        f.type === "mouseenter" && P();
        return;
      }
      t.mode === "click" && f.type === "click" && (o.value ? H() : P());
    }
    U(() => t.modelValue, (f) => {
      f && t.mode === "manual" ? P() : !f && (t.mode === "manual" || t.mode === "click") && H();
    }), me(() => {
      if (t.mode === "manual" && t.modelValue && P(), Z(document, "click", N), i.value) {
        const f = oe(i.value);
        f && Z(f, "scroll", H);
      }
    });
    const de = () => {
      const f = t.disabled ? {} : {
        type: "button",
        onMouseenter: V,
        onFocusin: V,
        onMouseleave: N,
        onFocusout: N,
        onClick: V,
        onKeypress: V
      };
      return O(
        t.disabled ? "div" : "button",
        {
          ...f,
          class: [
            "trigger",
            { "trigger--disabled": t.disabled }
          ],
          "data-testid": "tooltipTrigger"
        },
        O(
          "div",
          { "data-testid": "triggerWrapper" },
          l.trigger()
        )
      );
    };
    return (f, K) => (v(), m("div", {
      ref_key: "tooltipWrapper",
      ref: i,
      "data-testid": "tooltipWrapper"
    }, [
      $(de),
      (v(), j(_e, {
        to: t.container
      }, [
        o.value ? (v(), m("div", fe({
          key: 0,
          ref_key: "tooltipElement",
          ref: n,
          "data-testid": "tooltipElement",
          class: `tooltip ${t.placement} ${t.colorScheme}`,
          style: ce.value
        }, f.$attrs), [
          r("div", Me, [
            L(f.$slots, "tooltip", {}, void 0, !0)
          ]),
          r("div", {
            class: z(`tooltip-arrow ${t.placement}`)
          }, null, 2)
        ], 16)) : I("", !0)
      ], 8, ["to"]))
    ], 512));
  }
}), Ae = /* @__PURE__ */ B(Ne, [["__scopeId", "data-v-23b20b51"]]), Ge = (a, e) => {
  const t = "http://www.w3.org/2000/svg", l = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.166 5a8.25 8.25 0 1111.668 11.667A8.25 8.25 0 014.166 4.999zM10 4.082a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-.75 4.25a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm-.833 2.5a.75.75 0 01.75-.75H10a.75.75 0 01.75.75v2.583h.083a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75v-2.583h-.083a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (a.title) {
    const i = document.createElementNS(t, "title");
    i.textContent = a.title, l.appendChild(i);
  }
  const o = Array.from((l == null ? void 0 : l.attributes) ?? []).reduce((i, n) => ({
    ...i,
    [n.name]: n.value
  }));
  return O(
    "svg",
    {
      ...o,
      ...e.attrs,
      role: "img",
      innerHTML: l.innerHTML
    }
  );
}, We = { class: "main-rating__score lightext" }, De = { class: "main-rating__average darktext" }, Ue = { class: "flex items-center space-x-1 darktext leading-4" }, je = { class: "main-rating__note" }, Ke = { class: "py-2 px-3" }, qe = { class: "lightext" }, Ze = { class: "main-rating__based main-rating__based--large" }, Qe = { class: "main-rating__based main-rating__based--short" }, Je = /* @__PURE__ */ k({
  __name: "MainRating",
  props: {
    data: {},
    colors: {},
    orientation: { default: "horizontal" },
    compactSize: { type: [String, Boolean], default: !1 },
    textStyle: { default: () => ({
      score: {
        size: "16px",
        weight: "600"
      },
      average: {
        size: "32px",
        weight: "600"
      },
      note: {
        size: "14px",
        weight: "600"
      },
      based: {
        size: "12px",
        weight: "400"
      }
    }) },
    showInfoBtn: { type: Boolean },
    tooltip: { default: () => ({
      placement: "top",
      zIndex: 99999,
      container: "body"
    }) },
    tooltipPlacement: {},
    tooltipZIndex: {}
  },
  setup(a) {
    T((l) => ({
      "02c39d04": e.colors.darkText,
      "6d0cb708": e.colors.lightText,
      "53ff22aa": e.textStyle.score.size,
      "57547ee1": e.textStyle.score.weight,
      "54f682bf": e.textStyle.average.size,
      "1017a494": e.textStyle.average.weight,
      ce7d73e0: e.textStyle.note.size,
      "741b60c7": e.textStyle.note.weight,
      "3e96cbae": e.textStyle.based.size,
      e6ebdac0: e.textStyle.based.weight
    }));
    const e = a, { t } = R(), { isHoverCapable: s } = be();
    return (l, o) => (v(), m("div", {
      class: z([
        "main-rating",
        `main-rating--${e.compactSize ? "horizontal" : e.orientation}`,
        e.compactSize ? `main-rating--compact-${e.compactSize}` : void 0
      ]),
      "data-testid": "main-rating"
    }, [
      r("p", We, [
        r("span", De, _(e.data.averageFormatted), 1),
        o[0] || (o[0] = r("span", null, " / ", -1)),
        r("span", null, _(e.data.maxScore), 1)
      ]),
      r("div", {
        class: z({ "flex flex-col items-center": e.orientation === "vertical" })
      }, [
        r("div", Ue, [
          r("p", je, _(e.data.noteFormatted), 1),
          e.showInfoBtn ? (v(), j(p(Ae), {
            key: 0,
            mode: p(s) ? "hover" : "click",
            placement: e.tooltip.placement,
            "z-index-tooltip": e.tooltip.zIndex,
            container: e.tooltip.container
          }, {
            trigger: C(() => [
              $(p(Ge), {
                "aria-label": p(t)("Information icon"),
                class: "w-4 h-4"
              }, null, 8, ["aria-label"])
            ]),
            tooltip: C(() => [
              r("div", Ke, [
                L(l.$slots, "providersInfo", {}, void 0, !0)
              ])
            ]),
            _: 3
          }, 8, ["mode", "placement", "z-index-tooltip", "container"])) : I("", !0)
        ]),
        r("div", qe, [
          r("p", Ze, _(p(t)("based on {number} reviews", { number: e.data.totalReviews })), 1),
          r("p", Qe, _(p(t)("{num} reviews", { num: e.data.totalReviews })), 1)
        ])
      ], 2)
    ], 2));
  }
}), $t = /* @__PURE__ */ E(Je, [["__scopeId", "data-v-cb8169b6"]]), Xe = {
  class: "review",
  "data-testid": "review-item"
}, Ye = {
  key: 0,
  class: "review__header"
}, et = { class: "review__body" }, tt = { class: "bold" }, at = /* @__PURE__ */ k({
  __name: "Review",
  props: {
    review: {}
  },
  setup(a) {
    return (e, t) => (v(), m("div", Xe, [
      e.review.title ? (v(), m("div", Ye, ' "' + _(e.review.title) + '" ', 1)) : I("", !0),
      r("div", et, _(e.review.text), 1),
      $(p(xe), {
        keypath: "Posted on {reviewer}",
        tag: "div",
        class: "review__footer"
      }, {
        reviewer: C(() => [
          r("span", tt, _(e.review.reviewer), 1)
        ]),
        _: 1
      })
    ]));
  }
}), ot = /* @__PURE__ */ E(at, [["__scopeId", "data-v-4d472757"]]), st = { class: "reviewList" }, lt = { class: "reviewList__header" }, nt = { class: "reviewList__filters" }, it = { key: 1 }, rt = { class: "reviewList__header mt-2" }, ct = /* @__PURE__ */ k({
  __name: "ReviewList",
  props: {
    reviews: {},
    reviewLanguages: {}
  },
  setup(a) {
    const e = a, { t } = R(), s = b("all"), l = b("all"), o = b(), i = x(() => {
      const u = [...new Set(e.reviews.map((h) => h.type))].map((h) => ({
        label: t(h),
        value: h.toLowerCase()
      }));
      return u.unshift({
        label: t("All traveler types"),
        value: "all"
      }), u;
    }), n = x(() => {
      const d = e.reviewLanguages.map((u) => ({
        label: u.language,
        value: u.langCode
      }));
      return d.unshift({
        label: t("All languages"),
        value: "all"
      }), d;
    }), c = () => {
      var d;
      (d = o.value) != null && d.scrollTo && o.value.scrollTo(0, 0);
    }, g = x(() => e.reviews.filter((d) => s.value === "all" && l.value === "all" ? !0 : s.value === "all" ? d.language.toLowerCase() === l.value : l.value === "all" ? d.type.toLowerCase() === s.value : d.type.toLowerCase() === s.value && d.language.toLowerCase() === l.value));
    return (d, u) => (v(), m("div", st, [
      r("h2", lt, _(p(t)("Highlighted reviews")), 1),
      r("div", nt, [
        $(p(Q), {
          modelValue: s.value,
          "onUpdate:modelValue": [
            u[0] || (u[0] = (h) => s.value = h),
            c
          ],
          options: i.value,
          class: "reviewList__filters--type",
          "data-testid": "review-type"
        }, null, 8, ["modelValue", "options"]),
        $(p(Q), {
          modelValue: l.value,
          "onUpdate:modelValue": [
            u[1] || (u[1] = (h) => l.value = h),
            c
          ],
          options: n.value,
          class: "reviewList__filters--language",
          "data-testid": "review-language"
        }, null, 8, ["modelValue", "options"])
      ]),
      r("div", {
        ref_key: "reviewsEl",
        ref: o,
        class: "reviewList__reviews",
        tabindex: "0"
      }, [
        g.value.length > 0 ? (v(), j(p(Le), {
          key: 0,
          items: g.value,
          "data-testid": "review-list"
        }, {
          default: C(({ item: h }) => [
            $(ot, { review: h }, null, 8, ["review"])
          ]),
          _: 1
        }, 8, ["items"])) : (v(), m("div", it, [
          r("p", rt, _(p(t)("No reviews found")), 1)
        ]))
      ], 512)
    ]));
  }
}), kt = /* @__PURE__ */ E(ct, [["__scopeId", "data-v-7175abcb"]]), dt = ["innerHTML"], ut = /* @__PURE__ */ k({
  __name: "PropertyRanking",
  props: {
    config: {},
    hightlightColor: {},
    fontSize: { default: "small" }
  },
  setup(a) {
    T((c) => ({
      fa8b81fe: n.value
    }));
    const e = a, { t } = R(), s = ae(), l = x(() => e.config.orLocName || e.config.hotelGeoname || e.config.hotelLocation), o = x(() => !e.config.topPercentType || e.config.topPercentType !== 2), i = x(() => {
      switch (e.config.hotelType) {
        case 2:
          return t("Resorts");
        case 3:
          return t("B&Bs");
        case 4:
          return t("Apartments");
        case 5:
          return t("Campsites");
        case 6:
          return t("Aparthotels");
        case 7:
          return t("Hostels");
        case 8:
          return t("Restaurants");
        default:
          return t("Hotels");
      }
    }), n = x(() => e.hightlightColor ?? s.actionColor.base);
    return (c, g) => (v(), m("p", {
      class: z([
        "propertyRating text-center leading-4",
        e.fontSize === "large" ? "text-lg" : "text-sm"
      ]),
      innerHTML: p(t)(
        "<em>TOP {position}</em> {hotelType} in {location}",
        {
          position: `${e.config.topPercent}${o.value ? "%" : ""}`,
          hotelType: i.value,
          location: l.value || ""
        }
      )
    }, null, 10, dt));
  }
}), St = /* @__PURE__ */ E(ut, [["__scopeId", "data-v-5f02573f"]]), pt = { class: "providersInfo font-base" }, vt = { class: "mb-2 font-semibold" }, mt = { class: "flex gap-1 items-baseline" }, _t = { class: "font-semibold" }, ft = {
  key: 0,
  class: "text-grey-500 text-xs"
}, gt = { class: "text-base item__score" }, ht = { class: "text-grey-500" }, wt = /* @__PURE__ */ k({
  __name: "ProvidersInfo",
  props: {
    data: {},
    direction: { default: "ltr" },
    textStyle: { default: () => ({
      score: {
        weight: "700"
      }
    }) }
  },
  setup(a) {
    T((s) => ({
      "625c066a": e.direction,
      "9996451a": e.textStyle.score.weight
    }));
    const e = a, { t } = R();
    return (s, l) => (v(), m("div", pt, [
      r("p", vt, _(p(t)("Reviews by Source")), 1),
      $(p(Ee), {
        items: e.data,
        direction: "column",
        responsive: !1,
        class: "leading-5"
      }, {
        name: C(({ item: o }) => [
          r("div", mt, [
            r("span", _t, _(o.name), 1),
            o.totalReviews ? (v(), m("span", ft, _(p(t)("{num} reviews", { num: o.totalReviews })), 1)) : I("", !0)
          ])
        ]),
        value: C(({ item: o }) => [
          r("span", gt, _(o.value.score), 1),
          r("span", ht, "/" + _(o.value.max), 1)
        ]),
        _: 1
      }, 8, ["items"])
    ]));
  }
}), zt = /* @__PURE__ */ E(wt, [["__scopeId", "data-v-7b33e715"]]), bt = {
  content: [
    "./src/**/*.html",
    "./src/**/*.{vue,js,ts}"
  ],
  theme: {
    colors: {
      grey: {
        100: "#F1F1F1",
        500: "#9E9E9E",
        900: "#333333"
      },
      black: "#000",
      white: "#FFF"
    },
    fontSize: {
      xs: ".75rem",
      s: ".8125rem",
      sm: ".875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "2rem",
      "4xl": "2.5rem"
    },
    fontFamily: {
      base: "system-ui, Arial, Helvetica, sans-serif"
    }
  }
};
function Ct() {
  return bt.theme;
}
export {
  $t as M,
  St as P,
  kt as R,
  Ee as V,
  zt as a,
  Ct as u
};
//# sourceMappingURL=useTailwindTheme.D1_4gifO.js.map
